export const CONTACTS_LISTS_ACCESS = 'contacts-lists-access';

// Scopes controlling whether a user can be assigned an object or eligible for
// assignment via lead rotation.
//  - workflows-assignment-access - added to parcels that grant assignment access (paid seats)
//  - workflows-assignment-access-legacy - added to legacy parcel that is applied to all portals up until 11/1/2018
//  - deactivated - represents a deactivated user
export const WORKFLOWS_ASSIGNMENT_ACCESS = 'workflows-assignment-access';
export const WORKFLOWS_ASSIGNMENT_ACCESS_LEGACY = 'workflows-assignment-access-legacy';
export const DEACTIVATED = 'deactivated';
export const BET_CREATE_COMPANIES_RESTRICTION = 'bet-create-companies-restriction';
export const BET_CREATE_COMPANIES_OVERRIDE = 'bet-companies-create';
export const WORKFLOWS_DEALS_SPECIFIC_ACTIONS_ACCESS = 'workflows-deals-access';
export const WORKFLOWS_TICKETS_SPECIFIC_ACTIONS_ACCESS = 'workflows-tickets-specific-actions-access';
export const WORKFLOWS_APP_ACCESS = 'workflows-app-access';
export const MARKETABLE_CONTACTS_ACCESS = 'marketable-contacts-access';
export const BUSINESS_UNITS_ACCESS = 'business-units-access';
export const TEAMS_ACCESS = 'teams-access';
export const PAYMENTS_POST_UNDERWRITING_ACCESS = 'commerce-payments-access';
export const SUBSCRIPTIONS_ACCESS = 'subscriptions-access';
export const EMAIL_TYPE_WORKFLOWS_ACCESS = 'email-type-workflows-access';
export const MARKETING_STARTER = 'workflows-contextual-marketing-starter';
export const FORMAT_DATA_ACCESS = 'workflows-format-data-access';
export const EMAIL_WRITE = 'email-write';
export const WEBHOOK_ACCESS = 'workflows-webhook-access';
export const WORKFLOWS_EXTENSION_ACTION_ACCESS = 'workflows-extension-action-access';
export const WORKFLOWS_LEADS_ACCESS = 'workflows-leads-access';
export const WORKFLOWS_CUSTOM_EMAIL_TOKEN_ACCESS = 'workflows-custom-email-token-access';